module.exports = __webpack_public_path__ + "static/media/youtube.07e47983.svg";